module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity10.fd0ad709.jpg";